import { render, staticRenderFns } from "./EncounterMedications.vue?vue&type=template&id=dd4dc1e4&"
import script from "./EncounterMedications.vue?vue&type=script&lang=js&"
export * from "./EncounterMedications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports